
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById("root");

// Create error boundary
const renderApp = () => {
  try {
    const root = createRoot(rootElement!);
    root.render(<App />);
  } catch (error) {
    console.error("Failed to render app:", error);
    
    // Display error on screen for debugging
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; color: red; font-family: sans-serif;">
          <h2>Error Rendering Application</h2>
          <pre style="background: #f7f7f7; padding: 10px; border-radius: 4px; overflow: auto;">${
            error instanceof Error ? error.message : String(error)
          }</pre>
          <p>Check the console for more details.</p>
        </div>
      `;
    }
  }
};

renderApp();
